import PanelMessages from "../../components/PanelMessages";

export default function StudentMessages() {
  return <PanelMessages apiPrefix="student" />;
}
